import { message, notification } from "antd";

type NotifyType = "success" | "error" | "info" | "warning";

const openNotify = (
  type: NotifyType,
  msg: string,
  description?: string,
  duration = 5
) => {
  if (description) {
    notification[type]({
      message: msg,
      description,
      duration,
    });
  } else {
    message[type](msg, duration);
  }
};

export const notify = {
  success: (msg: string, description?: string) =>
    openNotify("success", msg, description, 3),

  error: (msg: string, description?: string) =>
    openNotify("error", msg, description, 5),

  info: (msg: string, description?: string) =>
    openNotify("info", msg, description, 4),

  warning: (msg: string, description?: string) =>
    openNotify("warning", msg, description, 4),

  loading: (msg: string) => message.loading(msg, 0),

  promise: async <T>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string;
      error: string;
    }
  ) => {
    const hide = message.loading(messages.loading, 0);
    try {
      const result = await promise;
      hide();
      notify.success(messages.success);
      return result;
    } catch (err) {
      hide();
      notify.error(messages.error);
      throw err;
    }
  },

  dismiss: () => {
    message.destroy();
    notification.destroy();
  },
};
